import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assets: [],
  refreshList: false,
};

const ownedAssetsSlice = createSlice({
  name: "ownedAssets",
  initialState,
  reducers: {
    addOwnedAssets: (state, action) => {
      const { data } = action.payload;
      state.assets = data;
    },
    isRefreshList: (state, action) => {
      state.refreshList = action.payload;
    },
  },
});

export default ownedAssetsSlice;
export const { addOwnedAssets, isRefreshList } = ownedAssetsSlice.actions;
